var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.51,
    height: 51.51,
    viewBox: "0 0 51.51 51.51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0,51.51h51.51V0H0v51.51ZM3.02,3.02h45.47v45.47H3.02V3.02Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.14,45.47h39.24v-18.21H6.14v18.21Zm24.15-3.02h-3.02v-12.17h3.02v12.17Zm3.02-12.17h3.02v12.17h-3.02v-12.17Zm-9.05,12.17h-3.02v-12.17h3.02v12.17Zm-6.04,0h-3.02v-12.17h3.02v12.17Zm24.15,0h-3.02v-12.17h3.02v12.17ZM9.16,30.28h3.02v12.17h-3.02v-12.17Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.14,24.25h39.24V6.04H6.14v18.21Zm24.15-3.02h-3.02v-12.17h3.02v12.17Zm3.02-12.17h3.02v12.17h-3.02v-12.17Zm-9.05,12.17h-3.02v-12.17h3.02v12.17Zm-6.04,0h-3.02v-12.17h3.02v12.17Zm24.15,0h-3.02v-12.17h3.02v12.17ZM9.16,9.05h3.02v12.17h-3.02v-12.17Z",
    fill: "#f0f0f0",
    strokeWidth: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.41d611ebf1338f5d1638e674360b9141.svg";
export { ForwardRef as ReactComponent };